import { type MutationError, trpc } from '@/shared/api';

interface UseMoveLandingHeroImageOptions {
  readonly onSuccess?: () => void;
}

/** 한 칸 위·아래로 옮긴다. 끝에서 더 못 가면 서버가 아무것도 바꾸지 않는다. */
export const useMoveLandingHeroImage = ({ onSuccess }: UseMoveLandingHeroImageOptions = {}) => {
  const mutation = trpc.landing.moveHeroImage.useMutation({ onSuccess });
  const error: MutationError | null = mutation.error;

  return {
    moveImage: (id: string, direction: 'UP' | 'DOWN') => mutation.mutate({ id, direction }),
    isPending: mutation.isPending,
    error,
    /** 지난 오류를 지운다 — 관리 화면의 다른 요청을 시작할 때 옛 오류가 남지 않게. */
    reset: mutation.reset,
  };
};
